import withWidth from '@mui/material/Hidden/withWidth'
import { observer } from 'mobx-react'
import React from 'react'
import NewRequestDrawer from '../components/NewRequestDrawer/NewRequestDrawer'
import DealerAllRequestsTables from '../components/NewRequestsTable/DealerAllTables'

function DealersRequestPage() {
  return (
    <>
      <DealerAllRequestsTables />
      <NewRequestDrawer />
    </>
  )
}

export default withWidth()(observer(DealersRequestPage))
